<template>
  <div class="remind">
    <div class="remind-msg" v-html="confirmMsg"></div>
    <div class="remind-tip">
      <div @click="handleCheck" class="check-mark">
        <span :class="{'checked': noRemind}" class="check-icon"></span>
        {{ remindTxt }}
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'GemRemind',
    props: {
      noRemind: Boolean,
      confirmMsg: String,
      remindTxt: String
    },
    methods: {
      handleCheck() {
        this.$emit('check')
        this.$bus.addGA('gemRemindCheckbox', 'click')
      }
    }
  }
</script>
<style lang="scss">
  .remind {
    width: 100%;
    @include px2res(height, 300);
    @include px2res(padding, 0, 50);
    @include flexcc;
    justify-content: flex-end;
    .remind-msg {
      width: 100%;
      line-height: 1.2;
      @include px2res(font-size, 46);
      .gem {
        @include px2res(padding, 0, 5);
        color: inherit;
        &::before {
          @include gem-icon(3, 3);
        }
      }
    }
    .remind-tip {
      width: 100%;
      @include px2res(margin, 40, 'auto', 50);
      @include px2res(font-size, 32);
    }
    .check-mark {
      @include one-line;
      display: inline-block;
      font-style: normal;
      .check-icon {
        position: relative;
        display: inline-block;
        @include px2res(margin-right, 12);
        @include px2res(width, 30);
        @include px2res(height, 30);
        @include px2res(vertical-align, -4);
        &.checked::after {
          content: '';
          position: absolute;
          @include px2res(bottom, 0);
          @include px2res(left, -6);
          @include px2res(width, 47);
          @include px2res(height, 38);
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/gem-remind/gem-remind.vue